import React from 'react';
import classNames from 'classnames';

import styles from './style.less';

const baseClass = styles.pageTitle;

module.exports = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    title: React.PropTypes.string.isRequired
  },
  getClass() {
    return classNames(baseClass, this.props.className);
  },
  render: require('./title.rt')
});


/** WEBPACK FOOTER **
 ** ./src/title/title/title.js
 **/